import React from 'react';
import PropTypes from 'prop-types';

const Location = ({ color = '#18964E', width = 7, height = 14 }) => (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3267 16.1758C12.3898 16.1758 10.8196 14.5388 10.8196 12.5195C10.8196 10.5002 12.3898 8.86328 14.3267 8.86328C16.2636 8.86328 17.8338 10.5002 17.8338 12.5195C17.8338 14.5388 16.2636 16.1758 14.3267 16.1758Z" stroke={color} stroke-width="1.5"/>
        <path d="M23.7465 10.3984C25.0392 16.3516 21.4871 21.3906 18.3734 24.5078C16.114 26.7813 12.5394 26.7813 10.2688 24.5078C7.16631 21.3906 3.61422 16.3398 4.90691 10.3867C7.12134 0.238284 21.5433 0.250003 23.7465 10.3984Z" stroke={color} stroke-width="1.5"/>
    </svg>
);

Location.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default Location; 